import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { languagesPipe } from '@utils/constants/languagesPipe';
import moment from 'moment';

@Pipe({
    name: 'validHourUndefined',
    standalone: false
})
export class ValidHourUndefinedPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: string, args?: any): any {
    const validLang = this.translateService.currentLang;
    const lang = languagesPipe[validLang];
    
    if (value.includes('undefined') || !moment(value, 'HH:mm').isValid()) {
      return 'N/A';
    }

    return value;
  }

}
